import { Card } from "antd";
import { useTranslation } from "react-i18next";
const EntertainmentCard = (props) => {
  const { t } = useTranslation();
  //console.log(props);
  const win = window;
  const serverURL = win["base_portal_url"]
    ? win["base_portal_url"]
    : window.location.origin;

  const onCardClick = () => {
    window.location.href = serverURL + props.data.pageUrl;
  };

  return (
    <div
      className="entertainmentInfo"
      style={{
        cursor: "pointer",

        background:
          "url('https://mobily.com.sa/MobilyTheme4Resources/img/mobily/Fill.png')  no-repeat",
        backgroundColor: "#003373",
        backgroundPosition: "50% 50%",
        backgroundSize: "cover",
      }}
      onClick={onCardClick}
    >
      <div
        className="entertainmentInfo"
        style={{
          background:
            " url(" +
            serverURL +
            props.data.image +
            ") center/cover no-repeat ",
        }}
      >
        {/* <div>
        {props.data.image ? (
          <img
            style={{
              height: "270px",
              borderRadius: "10px",
              maxWidth: "333px",
            }}
            src={serverURL + props.data.image}
            alt={props.data.title}
          />
        ) : null}
      </div> */}
        <div className="entertainmentDetails">
          <div className="entertainmentTitle">{props.data.title}</div>
          <div className="entertainmentDescription">{props.data.desc}</div>
        </div>
        {props.data.Price ? (
          <div className="entertainmentPrice">
            {props.data.Price}{" "}
            <span className="priceUnit">
              {t("SAR")}/{props.data.benifits.duration}
            </span>
          </div>
        ) : null}
      </div>
    </div>
  );
};
export default EntertainmentCard;
